module.exports = __webpack_public_path__ + "static/media/MacPortraitw300@2x.947284fa.webp";